import React from 'react';
import {DataTypeProvider} from '@devexpress/dx-react-grid';
import ChipFormatter from 'util/components/ChipFormatter';

const ChipProvider = (props) => <DataTypeProvider formatterComponent={ChipFormatter} {...props} />;

export default ChipProvider;
